import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { Choice } from 'app/dialogs/dialog-buttons.component';
import { ErrorDialogComponent
       } from 'app/dialogs/error-dialog/error-dialog.component';
import { Utils } from 'core/utils';
import { AsyncEventEmitterSubscriber
       } from 'core/utils/async-event-emitter';
import { CriticalError, ErrorBase } from './error';
import { ErrorService } from './error.service';

@Component({
    selector: 'error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent implements OnDestroy
{
  public criticalError: CriticalError;
  public errorUrl: string = Utils.url(
      './assets/img/error/critical-error-jigsaw.png');

  private errorService: ErrorService;
  private errorsOccurredSubscription:
      AsyncEventEmitterSubscriber<Array<ErrorBase>, Choice|undefined>;

  public constructor(
      private dialog: MatDialog,
      @Inject(ErrorService) errorService: ErrorService
  )
  {
    this.errorService = errorService;

    this.errorsOccurredSubscription = this.errorService
      .errorsOccurred.subscribe(async (errors: Array<ErrorBase>
                                      ): Promise<Choice|undefined> => {
        let config = new MatDialogConfig;
        config.data = {
          errors: errors,
          buttons: errors[0].buttons,
        };
        config.panelClass = 'dialog-pane';
        config.disableClose = !errors.every(e => e.closeable);
        return await this.dialog
          .open(ErrorDialogComponent, config)
          .afterClosed()
          .toPromise();
      });

    this.errorService.criticalErrorOccurred.subscribe((criticalError) => {
      this.criticalError = criticalError;
    });
  }

  public ngOnDestroy(): void
  {
    this.errorService.errorsOccurred.unsubscribe(
        this.errorsOccurredSubscription);
    this.errorService.criticalErrorOccurred.unsubscribe();
  }
}
